var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "#A7A7A7",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v10m18-9.588V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v.412l8 4.444zM2 5.7V13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5.7l-7.514 4.174a1 1 0 0 1-.971 0z",
    clipRule: "evenodd"
  })));
};
export default SvgEmail;